import React from 'react';
import { CheckCircleIcon, CalendarIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function FinalCTA() {
  const callBenefits = ['We look for your recruiting bottlenecks.', 'We map out a custom system for your team.', 'We tell you honestly if we are a fit.'];
  return <section className="section-padding bg-white" data-id="element-266">
      <div className="container-custom" data-id="element-267">
        <div className="max-w-4xl mx-auto text-center" data-id="element-268">
          <div className="inline-block bg-slate/10 text-slate px-4 py-2 rounded text-sm font-semibold mb-4 md:mb-6" data-id="element-269">
            Ready to Scale?
          </div>

          <h2 className="mb-4 md:mb-6" data-id="element-270">Build Your Recruiting System</h2>

          <p className="text-body-large mb-8 md:mb-10 lg:mb-12 leading-relaxed" data-id="element-271">
            If you want a real framework that works without you micromanaging
            it, let's talk. No pressure. Just a strategy session.
          </p>

          <div className="bg-gray-50 rounded p-6 md:p-8 lg:p-12 mb-8 md:mb-10 lg:mb-12 border-2 border-gray-200" data-id="element-272">
            <div className="flex items-center justify-center mb-4 md:mb-5 lg:mb-6" data-id="element-273">
              <CalendarIcon className="h-6 w-6 md:h-7 md:w-7 lg:h-8 lg:w-8 text-slate mr-2 md:mr-3" data-id="element-274" />
              <h3 data-id="element-275">What Happens on the Call</h3>
            </div>

            <ul className="space-y-3 md:space-y-4 text-left max-w-2xl mx-auto" data-id="element-276">
              {callBenefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-277">
                  <CheckCircleIcon className="h-5 w-5 md:h-6 md:w-6 text-slate flex-shrink-0 mr-2 md:mr-3 mt-0.5" data-id="element-278" />
                  <span data-id="element-279">{benefit}</span>
                </li>)}
            </ul>
          </div>

          <Button size="lg" href="/book-call" showArrow data-id="element-280">
            Schedule Your Strategy Call
          </Button>
        </div>
      </div>
    </section>;
}